(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("infra3dapi", [], factory);
	else if(typeof exports === 'object')
		exports["infra3dapi"] = factory();
	else
		root["infra3dapi"] = factory();
})(self, () => {
return 